<script setup lang="ts">
import { inject, Ref, computed } from "vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { vMaska } from "maska/vue";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { PageDesign } from "../page/PageInterface";
import { FieldStyle } from "@/builder/enums";

defineProps(["component"]);
const store = useRenderStore();

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});
</script>

<template>
    <div class="form-row rd-gap-x-4 phone-container">
        <ValidatedInput :id="component.id" :value="store.donor.phone" :label="component.customData.label"
            name="Donor.Phone" class="rd-w-full" :class="{ 'form-compact-full': fieldStyle == FieldStyle.Compact }"
            :isRequired="component.customData.required">
            <template #input="inputProps">
                <input type="tel" :id="component.id + '_Donor.Phone'" :placeholder="component.customData.placeholder"
                    :aria-describedby="inputProps.describedBy" :aria-required="inputProps.required"
                    :aria-invalid="inputProps.isInvalid" v-model="store.donor.phone" v-maska data-maska="(###) ###-####"
                    autocomplete="tel">
            </template>

            <template #extraContent>
                <div v-if="component.customData.showOptIn" class="rd-w-full rd-mt-2 rd-relative">
                    <div class="form-element-wrapper">
                        <input id="smsOptIn" type="checkbox" class="rd-relative" v-model="store.donor.phoneOptIn">
                        <label class="rd-font-normal rd-mb-0 rd-ml-2.5 rd-mt-px" for="smsOptIn">
                            {{ component.customData.optInLabel }}
                        </label>
                    </div>
                </div>
            </template>
        </ValidatedInput>
    </div>
</template>
